import React from 'react'
import {Link} from 'react-router-dom';

const DiscLogo = () => {
    return (
        <div className="Logo">
            <Link to="/">
                <img width={175} height={55} src={process.env.PUBLIC_URL + '/assets/disc.png'} alt=""/>
            </Link>
        </div>
    )
};

export default DiscLogo;
